import { Icon } from '~/components';

export const BREADCRUMBS_PROPS = {
  ROOT: {
    className: 'flex items-center justify-start self-stretch text-body-xs',
    separator: (
      <Icon type="chevron-right" size="md" role="presentation" aria-hidden />
    ),
  },
  ITEM_LINK: {
    className: 'font-semibold underline transition text-hover hover:text-white',
  },
};
